// ถ้าเปิดผ่าน In-App Browser ของ LINE ให้เด้งออกไปเปิดใน Browser จริงของเครื่อง
// (Safari / Chrome default) แทน
//
// เหตุผล: LINE in-app browser ไม่แชร์ session/cookie กับ browser หลักของเครื่อง
// เวลา login ด้วย Google Account มันจะไม่จำ user ต้องกรอกใหม่ทุกครั้ง
// เพราะฉะนั้นเวลามีคนแชร์ลิงก์ POS กันผ่าน LINE แล้วเปิด ให้เด้งไป browser นอกทันที
//
// วิธีของ LINE: navigate ไป URL ที่มี query `openExternalBrowser=1`
// LINE จะเปิด URL นั้นด้วย default browser ของเครื่องแทน in-app webview
// (ต้องเป็น host เดิมของแอปได้ — ที่นี่เราชี้ไป app2.niceloop.com ตามที่ตกลงไว้)
//
// รันเป็น pre-plugin และตั้งชื่อให้มาก่อน 00.bootstrap-guard เพื่อจับ URL เดิม
// (path/query) ไว้ ก่อนที่ bootstrap-guard จะ replace เป็น '/'

const EXTERNAL_HOST = 'https://app2.niceloop.com';
const EXTERNAL_PARAM = 'openExternalBrowser'; // LINE's own scheme flag

// LINE UA ทั้ง iOS และ Android มี token "Line/x.x.x" เสมอ
const isLineInAppBrowser = (ua: string) => /\bline\//i.test(ua);

export default defineNuxtPlugin({
  name: 'line-external-browser',
  enforce: 'pre',
  setup() {
    if (!import.meta.client) return;

    const ua = window.navigator.userAgent || '';
    if (!isLineInAppBrowser(ua)) return;

    const url = new URL(window.location.href);

    // ถ้าเราใส่ flag ไปแล้ว (เผื่อ LINE ยังไม่เด้งออกด้วยเหตุผลใดก็ตาม)
    // อย่า loop ซ้ำ
    if (url.searchParams.has(EXTERNAL_PARAM)) return;

    // คง path + query + hash เดิมไว้ แล้วเปลี่ยนไปยัง host ภายนอก
    const target = new URL(EXTERNAL_HOST);
    target.pathname = url.pathname;
    target.search = url.search;
    target.hash = url.hash;
    target.searchParams.set(EXTERNAL_PARAM, '1');

    console.log('[line-external-browser] LINE in-app detected, opening in external browser', {
      to: target.href,
    });

    window.location.replace(target.href);
  },
});
